module.exports = __webpack_public_path__ + "fd1e138215fafb6217cc9431bf4c3b75.png";